import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import NavBar from "./Components/NavBar/NavBar";
import {BrowserRouter, Route, Routes} from "react-router";
import {Index} from "./Components/Index/Index";
import Footer from "./Components/Footer/Footer";
import Servicios from "./Components/Servicios/Servicios";
import AllServices from "./Components/AllServices/AllServices";
import wp from "./media/wp.png"
import TuPedido from "./Components/TuPedido/TuPedido";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <NavBar/>
        <a href="https://wa.me/525528943351" className={"wp"} target={"_blank"}><img src={wp} alt=""/></a>
        <Routes>
            <Route path="/" element={<Index/>} />
            <Route path="/servicios" element={<Servicios/>} />
            <Route path="/todos-los-servicios" element={<AllServices/>} />
            <Route path="/tu_pedido" element={<TuPedido/>} />
        </Routes>
        <Footer/>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
